import script from "./configurations.vue?vue&type=script&setup=true&lang=ts"
export * from "./configurations.vue?vue&type=script&setup=true&lang=ts"

import "./configurations.vue?vue&type=style&index=0&id=9c56d5f0&lang=scss"

const __exports__ = script;

export default __exports__